const parseValue = value => {
  if (value instanceof Array) return value.join(',')
  return value
}

export default function queryStringParser(query) {
  if (!query) return ''

  return Object.keys(query)
    .filter(key => query[key] != null && query[key] !== '')
    .map(key => `${key}=${parseValue(query[key])}`)
    .join('&')
}



// WEBPACK FOOTER //
// ./src/alelo-logic/utils/queryStringParser.js